import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

export const Wrapper = styled.section`
	padding: 32px 0 48px;

	${minWidth('tablet')} {
		padding: 140px 0 120px;
	}
`;

export const HeadingContainer = styled.div`
	margin-bottom: 24px;
	text-align: center;

	${minWidth('tablet')} {
		margin-bottom: 96px;
	}
`;

export const Heading = styled.h3`
	color: ${palette('gray7')};
	${fontWeight(FontWeights.Medium)}
	margin-bottom: 24px;
`;

export const UserRating = styled.div`
	display: flex;
	justify-content: center;
	text-align: left;

	${minWidth('tablet')} {
		align-items: center;
	}
`;

export const User = styled.div<{ $backgroundUrl: string }>`
	background: url(${p => p.$backgroundUrl});
	background-size: cover;
	border: 2px ${palette('white')} solid;
	border-radius: 50%;
	flex: 0 0 48px;
	height: 48px;
	position: relative;
	width: 48px;

	&:nth-child(1) {
		margin-left: 0;
		z-index: 0;
	}

	&:nth-child(2) {
		margin-left: -24px;
		z-index: 1;
	}

	&:nth-child(3) {
		margin-left: -24px;
		z-index: 2;
	}

	${minWidth('tablet')} {
		flex: 0 0 72px;
		height: 72px;
		width: 72px;

		&:nth-child(2) {
			margin-left: -32px;
		}

		&:nth-child(3) {
			margin-left: -32px;
		}
	}
`;

export const RatingContainer = styled.div`
	padding-left: 24px;
	width: 50%;

	${minWidth('tablet')} {
		width: auto;
	}
`;

export const NumUsers = styled.p`
	color: ${palette('gray7')};
	font-size: 20px;
	margin-top: 4px;

	${minWidth('tablet')} {
		padding-right: 60px;
	}
`;
